import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export interface SidebarState {
  collapsed: boolean;
  activeGroupId: string | null;
  mobileOpen: boolean;
}

const initialState: SidebarState = {
  collapsed: false,
  activeGroupId: 'dashboard',
  mobileOpen: false,
};

const sidebarSlice = createSlice({
  name: 'sidebar',
  initialState,
  reducers: {
    toggleCollapse(state) {
      state.collapsed = !state.collapsed;
    },
    setCollapsed(state, action: PayloadAction<boolean>) {
      state.collapsed = action.payload;
    },
    setActiveGroup(state, action: PayloadAction<string | null>) {
      state.activeGroupId = action.payload;
    },
    toggleMobileOpen(state) {
      state.mobileOpen = !state.mobileOpen;
    },
    setMobileOpen(state, action: PayloadAction<boolean>) {
      state.mobileOpen = action.payload;
    },
  },
});

export const { toggleCollapse, setCollapsed, setActiveGroup, toggleMobileOpen, setMobileOpen } =
  sidebarSlice.actions;
export default sidebarSlice.reducer;
